{
    "account": "Account",
    "system_info": "System info",
    "dashboard": "Dashboard",
    "opos_list": "OPOS list",
    "subscriptions": "Subscriptions",
    "credit_card": "Cards",
    "employees": "Employees",
    "cost_centers": "Cost centers",
    "vendors": "Vendors",
    "reporting": "Reporting",
    "ai_reporting": "Global Insights",
    "settings": "Settings",
    "logout": "Logout",
    "login": "Login",
    "register": "Sign up",
    "forgot_password": "Forgot password?",
    "imprint": "Imprint",
    "privacy": "Privacy",
    "terms_of_use": "Terms of use",
    "go_back": "Go Back",
    "go_back_to_homepage": "Go back to homepage",
    "back_to_requests": "Back to requests",
    "back_to_login": "Back to login",
    "back_to_subscriptions": "Back to subscriptions",
    "bug_report": "Give feedback",
    "help_center": "Help center",
    "transactions": "Transactions",
    "workflows": "Workflows",
    "liquidity": "Liquidity",
    "cashflow_planning": "Cashflow planning",
    "category_settings": "Categorization",
    "user_management": "User management",
    "purchase_orders": "Purchase orders",
    "delivery_notes": "Delivery notes"
}
